import React, { Component } from 'react';
import { passwordCompare, passwordLength, required } from '@src/validation';
import { Alert, Col, Container, Row } from 'reactstrap';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from '@assets/images/logo.png';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { Link } from 'react-router-dom';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import { Redirect } from 'react-router';
import Style from '@src/components/Login/Login.module.scss';

const fieldValidator = {
  password: [required, passwordLength],
  repassword: [required, passwordLength]
};
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const fields = {};
    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields, submitted: false };
    props.onCheckHash(props.hash);
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }
    if (name === 'repassword' && inputData.error === false) {
      let validationPass = passwordCompare(
        inputData.value,
        this.state.password.value
      );
      if (validationPass !== undefined) {
        inputData.error = validationPass;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = event => {
    event.preventDefault();

    const userData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = userData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](userData[key].value);
        userData[key].visited = true;
        if (validationMsg !== undefined) {
          userData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          userData[key].error = false;
        }
      }
      if (key === 'repassword' && userData[key].error === false) {
        let validationPass = passwordCompare(
          userData[key].value,
          this.state.password.value
        );
        if (validationPass !== undefined) {
          userData[key].error = validationPass;
          isValid = false;
        }
      }
    });

    this.setState({ ...userData });

    if (isValid) {
      this.props.onSubmit(this.props.hash, postData);
    }
    return false;
  };

  render = () => {
    const { isMobile, email, isLogged } = this.props;

    return (
      <Container fluid={true} className={'h-100 text-center'}>
        {isLogged && <Redirect to="/" />}
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
          className={Style['form-signin']}
        >
          {this.props.loading && (
            <ProgressBox
              text={'Submitting ...'}
              icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
            />
          )}
          <div className={'d-flex align-items-center w-100'}>
            <div className={'w-100'}>
              <img
                src={Logo}
                className={'mx-auto d-block ' + (isMobile ? 'mt-4' : '')}
                alt={'Company Logo'}
                style={{width: '200px'}}
              />

              <div className={'text-center font-weight-bold font-xl mb-2 mt-2'}>
                Reset Password
              </div>
              {(this.props.error === null || this.props.submitted) && (
                <p className={'text-center'}>Reset Password for {email}</p>
              )}
              {this.props.error !== null && (
                <Col xs={10} md={7} className={'mx-auto'}>
                  <Alert color={'danger'}>{this.props.error}</Alert>
                </Col>
              )}

              {this.props.error === null || this.props.submitted ? (
                <React.Fragment>
                  <Row className={'justify-content-center text-left'}>
                    <Col xs={12}>
                      <LabelInput
                        name={'New Password'}
                        type={'password'}
                        required={true}
                        {...this.state.password}
                        onChange={event => this.updateForm(event, 'password')}
                      />
                    </Col>
                    <Col xs={12}>
                      <LabelInput
                        name={'Confirm New Password'}
                        type={'password'}
                        required={true}
                        {...this.state.repassword}
                        onChange={event => this.updateForm(event, 'repassword')}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={10} className={'mx-auto text-center'}>
                      <button
                        type={'submit'}
                        className={'btn btn-primary btn-lg mt-3 '}
                      >
                        Reset Password
                      </button>

                      <hr />
                      <div>
                        Already have an account? <Link to={'/'}>Login</Link>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : (
                <Row className={'pb-5'}>
                  <Col xs={10} className={'mx-auto text-center pb-5'}>
                    <hr />
                    <div>
                      Already have an account? <Link to={'/'}>Login</Link>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </form>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.forgotPassword.loading,
    error: state.forgotPassword.error,
    success: state.forgotPassword.success,
    email: state.forgotPassword.email
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (hash, postData) =>
      dispatch(actions.forgotPasswordResetPassword(hash, postData)),
    onCheckHash: hash => dispatch(actions.forgotPasswordCheckHash(hash))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);
